import { t } from '@lingui/macro'
import { ByBitTransactionHistory } from '@/services/bybit'

export const getBybitHistoryKeysTranslations = (): Record<keyof ByBitTransactionHistory, string> => {
  return {
    transactionTime: t({
      id: 'exchangeHistoryBybit.transactionTime',
      comment: 'Transaction time',
    }),
    type: t({
      id: 'exchangeHistoryBybit.type',
      comment: 'Type',
    }),
    symbol: t({
      id: 'exchangeHistoryBybit.symbol',
      comment: 'Symbol',
    }),
    currency: t({
      id: 'exchangeHistoryBybit.currency',
      comment: 'Currency',
    }),
    change: t({
      id: 'exchangeHistoryBybit.change',
      comment: 'Change',
    }),
    cashBalance: t({
      id: 'exchangeHistoryBybit.cashBalance',
      comment: 'Cash Balance',
    }),

    side: t({
      id: 'exchangeHistoryBybit.side',
      comment: 'Side',
    }),
    funding: t({
      id: 'exchangeHistoryBybit.funding',
      comment: 'Funding',
    }),
    orderLinkId: t({
      id: 'exchangeHistoryBybit.orderLinkId',
      comment: 'Order LinkId',
    }),
    orderId: t({
      id: 'exchangeHistoryBybit.orderId',
      comment: 'Order Id',
    }),
    fee: t({
      id: 'exchangeHistoryBybit.fee',
      comment: 'Fee',
    }),
    cashFlow: t({
      id: 'exchangeHistoryBybit.cashFlow',
      comment: 'CashFlow',
    }),
    feeRate: t({
      id: 'exchangeHistoryBybit.feeRate',
      comment: 'Fee Rate',
    }),
    bonusChange: t({
      id: 'exchangeHistoryBybit.bonusChange',
      comment: 'Bonus Change',
    }),
    size: t({
      id: 'exchangeHistoryBybit.size',
      comment: 'Size',
    }),
    qty: t({
      id: 'exchangeHistoryBybit.qty',
      comment: 'QTY',
    }),
    id: t({
      id: 'exchangeHistoryBybit.id',
      comment: 'ID',
    }),
    category: t({
      id: 'exchangeHistoryBybit.category',
      comment: 'Category',
    }),
    tradePrice: t({
      id: 'exchangeHistoryBybit.tradePrice',
      comment: 'Trade Price',
    }),
    tradeId: t({
      id: 'exchangeHistoryBybit.tradeId',
      comment: 'Trade Id ',
    }),
  }
}
/*
export const getBybitTypes = (): Record<string, string> => {
  return {
    TRANSFER_IN: t({
      id: 'exchangeHistoryBybit.type.transferIn',
      comment: 'Assets that transferred into Unified wallet',
    }),
    TRANSFER_OUT: t({
      id: 'exchangeHistoryBybit.type.transferOut',
      comment: 'Assets that transferred out from Unified wallet',
    }),
    TRADE: t({
      id: 'exchangeHistoryBybit.type.trade',
      comment: '',
    }),
    SETTLEMENT: t({
      id: 'exchangeHistoryBybit.type.settlement',
      comment: 'USDT Perp funding settlement, and USDC Perp funding settlement + USDC 8-hour session settlement',
    }),
    DELIVERY: t({
      id: 'exchangeHistoryBybit.type.delivery',
      comment: 'USDC Futures, Option delivery',
    }),
    LIQUIDATION: t({
      id: 'exchangeHistoryBybit.type.liquidation',
      comment: '',
    }),
    AIRDROP: t({
      id: 'exchangeHistoryBybit.type.airdrop',
      comment: '',
    }),
    BONUS: t({
      id: 'exchangeHistoryBybit.type.bonus',
      comment: 'Bonus claimed',
    }),
    BONUS_RECOLLECT: t({
      id: 'exchangeHistoryBybit.type.bonusRecollect',
      comment: 'Bonus expired',
    }),
    FEE_REFUND: t({
      id: 'exchangeHistoryBybit.type.feeRefound',
      comment: 'Trading fee refunded',
    }),
    INTEREST: t({
      id: 'exchangeHistoryBybit.type.interest',
      comment: 'Interest occurred due to borrowing',
    }),
    CURRENCY_BUY: t({
      id: 'exchangeHistoryBybit.type.currencyBuy',
      comment: 'Currency convert, and the liquidation for borrowing asset',
    }),
    CURRENCY_SELL: t({
      id: 'exchangeHistoryBybit.type.currencySell',
      comment: 'Currency convert, and the liquidation for borrowing asset',
    }),
    BORROWED_AMOUNT_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.borrowedAmountInsLoan',
      comment: '',
    }),
    PRINCIPLE_REPAYMENT_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.principleRepaymentInsLoan',
      comment: '',
    }),
    INTEREST_REPAYMENT_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.interestRepaymentInsLoan',
      comment: '',
    }),
    AUTO_SOLD_COLLATERAL_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.autoSoldCollateralInsLoan',
      comment: '',
    }),
    AUTO_BUY_LIABILITY_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.autoBuyLiabilityInsLoan',
      comment: '',
    }),
    AUTO_PRINCIPLE_REPAYMENT_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.autoPrincipleRepaymentInsLoan',
      comment: '',
    }),
    AUTO_INTEREST_REPAYMENT_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.autoInterestRepaymentInsLoan',
      comment: '',
    }),
    TRANSFER_IN_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.transferInInsLoan',
      comment: 'Transfer In when in the liquidation of OTC loan',
    }),
    TRANSFER_OUT_INS_LOAN: t({
      id: 'exchangeHistoryBybit.type.transferOutInsLoan',
      comment: 'Transfer Out when in the liquidation of OTC loan',
    }),
    SPOT_REPAYMENT_SELL: t({
      id: 'exchangeHistoryBybit.type.spotRepaymentSell',
      comment: 'One-click repayment currency sell',
    }),
    SPOT_REPAYMENT_BUY: t({
      id: 'exchangeHistoryBybit.type.spotRepaymentBuy',
      comment: 'One-click repayment currency buy',
    }),
    TOKENS_SUBSCRIPTION: t({
      id: 'exchangeHistoryBybit.type.tokensSubscription',
      comment: 'Spot leverage token subscription',
    }),
    TOKENS_REDEMPTION: t({
      id: 'exchangeHistoryBybit.type.tokensRedemption',
      comment: 'Spot leverage token redemption',
    }),
    AUTO_DEDUCTION: t({
      id: 'exchangeHistoryBybit.type.autoDeduction',
      comment: 'Asset auto deducted by system (roll back)',
    }),
    FLEXIBLE_STAKING_SUBSCRIPTION: t({
      id: 'exchangeHistoryBybit.type.flexibleStakingSubscription',
      comment: 'Byfi flexible stake subscription',
    }),
    FLEXIBLE_STAKING_REDEMPTION: t({
      id: 'exchangeHistoryBybit.type.flexibleStakingRedemption',
      comment: 'Byfi flexible stake redemption',
    }),
    FIXED_STAKING_SUBSCRIPTION: t({
      id: 'exchangeHistoryBybit.type.fixedStakingSubscription',
      comment: 'Byfi fixed stake subscription',
    }),
  }
}
*/
